<template>
  <h2 class="mb-6 font-medium text-heading text-brand-gray-900">Přednášky</h2>

  <section id="prednasky" class="flex flex-col items-center justify-center">
    <VotingCard :userLoggedIn="userLoggedIn" :selectedHappening="selectedHappening" class="mt-2" v-for="(happening, i) in talks" :key="i" :votingOpened="votingOpened" :card-data="happening" />
  </section>

  <h2 class="mt-16 mb-6 font-medium text-heading text-brand-gray-900">Case-Studies</h2>

  <section id="casestudies" class="flex flex-col items-center justify-center">
    <VotingCard :userLoggedIn="userLoggedIn" :selectedHappening="selectedHappening" class="mt-2" v-for="(happening, i) in caseStudies" :key="i" :votingOpened="votingOpened" :card-data="happening" />
  </section>

  <h2 class="mt-16 mb-6 font-medium text-heading text-brand-gray-900">Workshopy</h2>

  <section id="workshopy" class="flex flex-col items-center justify-center mb-24">
    <VotingCard :userLoggedIn="userLoggedIn" :selectedHappening="selectedHappening" class="mt-2" v-for="(happening, i) in workshops" :key="i" :votingOpened="votingOpened" :card-data="happening" />
  </section>
</template>

<script>

import VotingCard from './VotingCard.vue';

export default {

  props: {
    votingOpened: {
      type: Boolean,
      default: false
    },
    happenings: {
      type: Array,
      default: () => []
    },
    selectedHappening: {
      type: Object,
      required: false
    },
    userLoggedIn: {
      type: Boolean,
      default: false
    }
  },

  components: {
    VotingCard
  },

  computed: {
    talks() {
      return this.happenings.filter(h => h.type === 'talk');
    },

    caseStudies() {
      return this.happenings.filter(h => h.type === 'caseStudy');
    },

    workshops() {
      return this.happenings.filter(h => h.type === 'workshop');
    }
  },



  data() {
    return {
      mock: [
        {
            photo: "/assets/speakers/david_cikanek.png",
            time: "10:00—10:45",
            name: "David Cikánek",
            position: "CSO",
            title: "Jak spasit svět ve 3 krocích? I název přednášky může být hodně dlouhý. Podporujeme dva řádky. Pokud to má někdo ještě delší Pokud to má někdo ještě delšíPokud to má někdo ještě delšíPokud to má někdo ještě delšíPokud to má někdo ještě delší",
            description:
              "Pandemie urychlila a uspíšila nevyhnutné. Čeští giganti naplno otevřeli stavidla a transformují se do formy tržišť. Stane se Maill či Alza českým  stavidla a transformují se do formy tržišť. Stane se Maill či Alza českým  stavidla a transformují se do formy tržišť. Stane se Maill či Alza českým  stavidla a transformují se do formy tržišť. Stane se Maill či Alza českým  stavidla a transformují se do formy tržišť. Stane se Maill či Alza českým",
            web: "",
            twitter: "",
            linkedin: "",
        }
      ]
    }
  }

}
</script>

<style>

</style>
